import { ref, watch } from "vue";

export type Theme = "dark" | "light";

const STORAGE_KEY = "timeclock.theme";

function _readStoredTheme(): Theme {
  if (typeof window === "undefined") {
    return "light";
  }
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === "dark" || stored === "light") {
    return stored;
  }
  return "light";
}

function _applyTheme(next: Theme) {
  if (typeof document === "undefined") {
    return;
  }
  document.documentElement.setAttribute("data-theme", next);
}

const theme = ref<Theme>(_readStoredTheme());

_applyTheme(theme.value);

watch(theme, (next) => {
  _applyTheme(next);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, next);
  }
});

function toggleTheme() {
  theme.value = theme.value === "dark" ? "light" : "dark";
}

function setTheme(nextTheme: Theme) {
  theme.value = nextTheme;
}

export function useTheme() {
  return {
    setTheme,
    theme,
    toggleTheme,
  };
}
